import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Shown when the backend refuses a request with 403. One shared id, so the
// interceptor's toast and a caller's own error toast collapse into one.
export const FORBIDDEN_MESSAGE = "You don't have permission to do that.";

export const Toast = (type, data) => {
  return toast(data, {
    toastId: data === FORBIDDEN_MESSAGE ? "forbidden" : undefined,
    type: type,
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
